class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._closeTimer = null;
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    if (window.innerWidth < 750) return;
    clearTimeout(this._closeTimer);

    this.mainDetailsToggle.setAttribute('open', '');

    const panel = this.mainDetailsToggle.querySelector('.mega-menu__content');
    if (!panel) return;

    requestAnimationFrame(() => {
      const panelWidth = panel.offsetWidth;
      if (!panelWidth) return;

      const navRect = this.getBoundingClientRect();
      const navCentre = navRect.left + navRect.width / 2;
      const idealLeft = navCentre - panelWidth / 2;
      const margin = 16;
      const clamped = Math.max(margin, Math.min(idealLeft, window.innerWidth - panelWidth - margin));

      // Convert viewport coords to local coords (details is position:relative)
      const detailsLeft = this.mainDetailsToggle.getBoundingClientRect().left;
      panel.style.left = `${clamped - detailsLeft}px`;
      panel.style.right = 'auto';
    });
  }

  onMouseLeave() {
    if (window.innerWidth < 750) return;
    this._closeTimer = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
    }, 120);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
